import { render, staticRenderFns } from "./MenuDrawer.vue?vue&type=template&id=90b209de&scoped=true"
import script from "./MenuDrawer.vue?vue&type=script&lang=js"
export * from "./MenuDrawer.vue?vue&type=script&lang=js"
import style0 from "./MenuDrawer.vue?vue&type=style&index=0&id=90b209de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b209de",
  null
  
)

export default component.exports